// extracted by css-extract-rspack-plugin
export default {"note":"HoverNote__note--PtmEm","shape":"HoverNote__shape--sH9WE","message":"HoverNote__message--LhFkQ"};